<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <el-form label-position="top" status-icon :model="hastaForm" :rules="rulesHasta" ref="hastaForm"
                 class="demo-ruleForm">
            <div class="card-base baslikBg animated fadeInLeft">Hasta Bilgileri</div>
            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <el-row>
                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='İsim Soyisim :' prop="adSoyad">
                                <el-input
                                        v-model="hastaForm.adSoyad"
                                        v-on:input="inputStyleAlt(hastaForm.adSoyad)"
                                        placeholder='İsim Soyisim Giriniz'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='T.C. No : ' prop="tcNo">
                                <el-input v-on:change="bilgiKontrol('TC No')" :disabled="this.hastaForm.dosyaNo !=='' || this.hastaForm.protokolNo !== ''"
                                          v-model="hastaForm.tcNo" v-mask="'###########'"
                                          placeholder='T.C. No Giriniz'></el-input>
                            </el-form-item>
                        </el-col>


                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Dosya No : ' prop="dosyaNo">
                                <el-input v-on:change="bilgiKontrol('Dosya No')" :disabled="this.hastaForm.tcNo !=='' || this.hastaForm.protokolNo !== ''"
                                          v-model="hastaForm.dosyaNo" v-mask="'#######'"
                                          placeholder='Dosya No Giriniz'></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Protokol No : ' prop="protokolNo">
                                <el-input v-on:change="bilgiKontrol('Protokol No')" :disabled="this.hastaForm.tcNo !=='' || this.hastaForm.dosyaNo !== ''"
                                          v-model="hastaForm.protokolNo" v-mask="'#######'"
                                          placeholder='Protokol No Giriniz'></el-input>
                            </el-form-item>
                        </el-col>


                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='E-Posta :' prop="eposta">
                                <el-input
                                        v-model="hastaForm.eposta"
                                        placeholder='E-Posta Giriniz'></el-input>
                            </el-form-item>
                        </el-col>


                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Telefon :' prop="telefon">
                                <el-input
                                        v-mask="'+90(###)### ## ##'"
                                        v-model="hastaForm.telefon"
                                        placeholder='Telefon Giriniz'></el-input>
                            </el-form-item>
                        </el-col>


                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='İl :' prop="il">
                                <el-select
                                        auto-complete="disable"
                                        v-model="hastaForm.il"
                                        filterable
                                        v-on:change="getIlSelect"
                                        placeholder='İl Seçiniz'
                                        style="width: 100%">
                                    <el-option v-for="item in ilList"
                                               :key="item.baslik"
                                               :label="item.baslik"
                                               :value="item.ilId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>


                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Yaş :' prop="yas">
                                <el-input
                                        v-model="hastaForm.yas"
                                        v-mask="'##'"
                                        placeholder='Yaş Giriniz'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Cinsiyet :' prop="cinsiyet">
                                <el-row :gutter="10" style="margin-top: 0">
                                    <el-col :lg="12" :md="12" :sm="12" :xs="24">
                                        <el-radio style="width: 100%; margin-right: 0 !important;"
                                                  v-model="hastaForm.cinsiyet" label="Kadın"
                                                  border
                                                  size="medium">
                                            <i style="color: deeppink;" class="mdi mdi-human-female"></i> Kadın
                                        </el-radio>
                                    </el-col>
                                    <el-col :lg="12" :md="12" :sm="12" :xs="24" class="mobil-margin">
                                        <el-radio style="width: 100%; margin-left: 0 !important;"
                                                  v-model="hastaForm.cinsiyet" label="Erkek"
                                                  border
                                                  size="medium">
                                            <i style="color: #337ab7;" class="mdi mdi-human-male"></i> Erkek
                                        </el-radio>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </div>
            <div class="card-base baslikBg margin-top-20 animated fadeInLeft">Ürün Bilgileri</div>
            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <el-row>
                        <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">

                            <el-form-item label='Ürün Kodu :' prop="oUrunId">
                                <el-select
                                        filterable
                                        v-model="hastaForm.urunList[0].oUrunId"
                                        placeholder='Ürün Kodu Seçiniz'
                                        v-on:change="getUrunDetay"
                                        style="width: 100%">
                                    <el-option v-for="item in oUrunList"
                                               :key="item.urunKodu"
                                               :label="item.urunKodu"
                                               :value="item.oUrunId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :lg="6" :md="6" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Ürün Adı : ' prop="urunAdi">
                                <el-input disabled
                                          v-model="hastaForm.urunList[0].urunAdi"
                                          placeholder='Ürün Adı Giriniz'></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Referans No : ' prop="referansNo">
                                <el-input disabled
                                          v-model="hastaForm.urunList[0].referansNo"
                                          placeholder='Referans No Giriniz'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Barkod No : ' prop="barkodNo">
                                <el-input disabled
                                          v-model="hastaForm.urunList[0].barkodNo"
                                          placeholder='Barkod No Giriniz'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='SUT Kodu : ' prop="sutKodu">
                                <el-input disabled
                                          v-model="hastaForm.urunList[0].sutKodu"
                                          placeholder='SUT Kodu Giriniz'></el-input>
                            </el-form-item>
                        </el-col>


                    </el-row>
                </el-col>
            </div>
            <div class="card-base baslikBg margin-top-20 animated fadeInLeft">Uygulama Bilgileri</div>
            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <el-row>
                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label="Uygulama Tarihi : " prop="tarih">
                                <el-date-picker
                                        style="width: 100%"
                                        v-model="hastaForm.urunList[0].tarih"
                                        type="datetime"
                                        :picker-options="dateRangeOptions"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="Uygulama Tarihi Seçiniz"
                                        default-time="12:00:00">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>


                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">

                            <el-form-item label='Hekim Adı :' prop="hekimId"
                                          :rules="{ required: true, message: 'Lütfen Hekim Adı Seçiniz', trigger: 'change'}">
                                <el-select
                                        v-model="hastaForm.hekimId"
                                        placeholder='Hekim Seçiniz'
                                        v-on:change="hetHekimKlinikList"
                                        style="width: 100%">
                                    <el-option v-for="item in oHekimList"
                                               :key="item.adSoyad"
                                               :label="item.adSoyad"
                                               :value="item.hekimId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                            <el-form-item label='Klinik Adı : ' prop="klinik"
                                          :rules="{ required: true, message: 'Lütfen Klinik Seçiniz', trigger: 'change'}">
                                <el-select
                                        v-model="hastaForm.klinik"
                                        placeholder='Klinik Adı Seçiniz'
                                        style="width: 100%">
                                    <el-option v-for="item in oHekimKlinikList"
                                               :key="item.baslik"
                                               :label="item.baslik"
                                               :value="item.klinikId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row>
                </el-col>
            </div>
            <el-col :lg="24" :md="24" :sm="24" :xs="24">
                <el-button v-on:click="hastaGuncelleme" class=" estas-buton ileriButton" size="small"
                           type="primary"
                           style="float: right;margin-top: 15px;margin-bottom: 15px">
                    Kaydet
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                        <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                    </svg>
                </el-button>
            </el-col>
        </el-form>
    </div>
</template>

<script>
    import hastaOrtopediService from "../../../WSProvider/HastaOrtopediService";
    import notification from "../../../notification";
    import urunOrtopediService from "../../../WSProvider/UrunOrtopediService";
    import ilService from "../../../WSProvider/IlService";
    import hekimService from "../../../WSProvider/HekimService";
    import ortopediIslemService from "../../../WSProvider/OrtopediIslemService";

    var gelenDetayListesi = [];


    export default {
        name: "OrtopediHastaGuncelleme",
        data() {
            return {
                hastaForm: {
                    adSoyad: '',
                    yas: '',
                    cinsiyet: '',
                    eposta: '',
                    telefon: '',
                    il: '',
                    tcNo: '',
                    dosyaNo: '',
                    protokolNo: '',
                    bilgi: '',
                    bilgiAdi: '',
                    hekimId: '',
                    klinik: '',

                    urunList: [{
                        tarih: '',
                        urunAdi: '',
                        referansNo: '',
                        barkodNo: '',
                        sutKodu: '',
                        oUrunId: '',
                        oUygulamaId: '',
                    }],
                },
                hastaFormKlon: {
                    adSoyad: '',
                    yas: '',
                    cinsiyet: '',
                    eposta: '',
                    telefon: '',
                    il: '',
                    dosyaNo: '',
                    protokolNo: '',
                    bilgi: '',
                    hekimId: '',
                    klinik: '',

                    urunList: [{
                        tarih: '',
                        urunAdi: '',
                        referansNo: '',
                        barkodNo: '',
                        sutKodu: '',
                        oUrunId: '',
                        oUygulamaId: '',
                    }],
                },

                dateRangeOptions: {
                    firstDayOfWeek: 1,
                    disabledDate: this.disabledDate
                },

                oTarihId: '',
                ilList: [],
                oUrunList: [],
                oHekimList: [],
                oHekimKlinikList: [],
                updateData: [],


                dialogVisibleHekim: false,

                rulesHasta: {
                    tcNo: [{
                        required: true,
                        message: "Lütfen T.C. No Giriniz",
                        trigger: 'change'
                    }],
                    adSoyad: [{
                        required: true,
                        message: "Lütfen İsim Soyisim Giriniz.",
                        trigger: 'change'
                    }],
                    yas: [{
                        required: true,
                        message: "Lütfen Yaş Seçiniz.",
                        trigger: 'change'
                    }],
                    cinsiyet: [{
                        required: true,
                        message: "Lütfen Cinsiyet Seçiniz.",
                        trigger: 'change'
                    }],
                    dosyaNo: [{
                        required: true,
                        message: "Lütfen Dosya No Giriniz.",
                        trigger: 'change'
                    }],
                    protokolNo: [{
                        required: true,
                        message: "Lütfen Protokol No Giriniz.",
                        trigger: 'change'
                    }],
                    il: [{
                        required: true,
                        message: "Lütfen Telefon Giriniz.",
                        trigger: 'change'
                    }],
                },
            }
        },
        mounted() {
            this.updateId = this.$store.state.updateKodu;
            this.getoUrunList();
            this.getIl();
            this.getHastaDetay();
        },

        methods: {
            bilgiKontrol(gelenBilgi) {
                switch (gelenBilgi) {
                    case 'TC No':
                        this.hastaForm.bilgiAdi = "TC No";
                        this.hastaForm.bilgi = this.hastaForm.tcNo;
                        break;
                    case 'Dosya No':
                        this.hastaForm.bilgiAdi = "Dosya No";
                        this.hastaForm.bilgi = this.hastaForm.dosyaNo;
                        break;
                    case 'Protokol No':
                        this.hastaForm.bilgiAdi = "Protokol No";
                        this.hastaForm.bilgi = this.hastaForm.protokolNo;
                        break;
                }
            },

            hastaGuncelleme() {
                let self = this;
                for (var i = 0; i < self.hastaForm.urunList.length; i++) {
                    let obj1 = JSON.parse(gelenDetayListesi).find(data => data.oUygulamaId === self.hastaForm.urunList[i].oUygulamaId);
                    if (obj1 === undefined) {
                        self.updateData.push({
                            durum: 1,
                            oUrunId: self.hastaForm.urunList[i].oUrunId,
                        });
                    } else {
                        if (obj1.oUrunId !== self.hastaForm.urunList[i].oUrunId) {
                            self.updateData.push({
                                durum: 2,
                                oUygulamaId: self.hastaForm.urunList[i].oUygulamaId,
                                oUrunId: self.hastaForm.urunList[i].oUrunId,
                            })
                        }
                    }
                }
                // for (var j = 0; j < JSON.parse(gelenDetayListesi).length; j++) {
                //     let obj0 = self.hastaForm.urunList.find(data => data.oUrunId === JSON.parse(gelenDetayListesi)[j].oUrunId);
                //     if (obj0 === undefined) {
                //         self.updateData.push({
                //             durum: 0,
                //             oUygulamaId: JSON.parse(gelenDetayListesi)[j].oUygulamaId,
                //         })
                //     }
                // }

                ///////
                var dizi = [];
                for (var key in this.hastaFormKlon) {
                    if (this.hastaFormKlon[key] !== this.hastaForm[key]) {
                        if (this.hastaForm[key] || this.hastaForm[key] === '') {
                            if (key !== "tcNo" && key !== "protokolNo" && key !== "dosyaNo" && key !== "urunList") {
                                var item = {
                                    type: key,
                                    value: this.hastaForm[key]
                                };
                                dizi.push(item);
                            }
                        }
                    }
                }


                if (dizi.length > 0) {
                    hastaOrtopediService.hastaOrtopediGuncelleme(this.updateId, dizi).then((response) => {
                        if (response.status === 200) {
                            notification.Status('success', this, 'Hasta başarıyla güncellendi.');
                        } else notification.Status(response.status, this)
                    })
                }
                if (this.updateData.length > 0) {
                    ortopediIslemService.ortopediGuncelle(this.oTarihId, this.updateData).then((response) => {
                        if (response.status === 200) {
                            notification.Status('success', this, 'Hasta ürün bilgisi başarıyla güncellendi.');
                        } else notification.Status(response.status, this)
                    })
                }
                if (dizi.length === 0 && this.updateData.length === 0) {
                    notification.Status('warning', this, 'Herhangi bir değişiklik yapılmadı.');
                }
            },
            getHastaDetay() {
                hastaOrtopediService.hastaOrtopediDetay(this.updateId).then((response) => {
                    if (response.status === 200) {
                        this.getIlSelect(response.data.ilId);
                        this.hetHekimKlinikList(response.data.hekimId);
                        this.getUrunDetay(response.data.detay[0].islemDetay[0].oUrunId);
                        this.getUrunDetayStart(response.data.detay[0].islemDetay[0].oUrunId);
                        this.bilgiKontrol(response.data.bilgiAdi);
                        this.hetHekimKlinikList(response.data.hekimId);

                        gelenDetayListesi = JSON.stringify(response.data.detay[0].islemDetay);
                        this.oTarihId = response.data.detay[0].oTarihId;

                        this.hastaForm.adSoyad = response.data.adSoyad;
                        this.hastaForm.cinsiyet = response.data.cinsiyet;
                        this.hastaForm.eposta = response.data.eposta;
                        this.hastaForm.il = response.data.ilId;
                        this.hastaForm.hekimId = response.data.hekimId;
                        this.hastaForm.klinik = response.data.klinik;
                        this.hastaForm.telefon = response.data.telefon;
                        this.hastaForm.yas = response.data.yas;
                        this.hastaForm.bilgi = response.data.bilgi;
                        this.hastaForm.urunList[0].oUrunId = response.data.detay[0].islemDetay[0].oUrunId;
                        this.hastaForm.urunList[0].tarih = response.data.detay[0].tarih;
                        this.hastaForm.urunList[0].oUygulamaId = response.data.detay[0].islemDetay[0].oUygulamaId


                        this.hastaFormKlon.adSoyad = response.data.adSoyad;
                        this.hastaFormKlon.cinsiyet = response.data.cinsiyet;
                        this.hastaFormKlon.eposta = response.data.eposta;
                        this.hastaFormKlon.il = response.data.ilId;
                        this.hastaFormKlon.telefon = response.data.telefon;
                        this.hastaFormKlon.yas = response.data.yas;
                        this.hastaFormKlon.bilgi = response.data.bilgi;
                        this.hastaFormKlon.bilgiAdi = response.data.bilgiAdi;
                        this.hastaFormKlon.hekimId = response.data.hekimId;
                        this.hastaFormKlon.klinik = response.data.klinik;
                        this.hastaFormKlon.urunList[0].oUrunId = response.data.detay[0].islemDetay[0].oUrunId;
                        this.hastaFormKlon.urunList[0].tarih = response.data.detay[0].tarih;
                        this.hastaFormKlon.urunList[0].oUygulamaId = response.data.detay[0].islemDetay[0].oUygulamaId;

                        switch (response.data.bilgiAdi) {
                            case "TC No":
                                this.hastaForm.tcNo = response.data.bilgi;
                                break;
                            case "Dosya No":
                                this.hastaForm.dosyaNo = response.data.bilgi;
                                break;
                            case "Protokol No":
                                this.hastaForm.protokolNo = response.data.bilgi;
                                break;
                        }

                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getUrunDetay(val) {
                urunOrtopediService.urunOrtopediDetay(val).then((response) => {
                    if (response.status === 200) {
                        this.hastaForm.urunList[0].referansNo = response.data.referansNo;
                        this.hastaForm.urunList[0].sutKodu = response.data.sutKodu;
                        this.hastaForm.urunList[0].urunAdi = response.data.urunAdi;
                        this.hastaForm.urunList[0].barkodNo = response.data.barkodNo;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getUrunDetayStart(val) {
                urunOrtopediService.urunOrtopediDetay(val).then((response) => {
                    if (response.status === 200) {
                        this.hastaFormKlon.urunList[0].referansNo = response.data.referansNo;
                        this.hastaFormKlon.urunList[0].sutKodu = response.data.sutKodu;
                        this.hastaFormKlon.urunList[0].urunAdi = response.data.urunAdi;
                        this.hastaFormKlon.urunList[0].barkodNo = response.data.barkodNo;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getIl() {
                ilService.il().then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getoUrunList() {
                urunOrtopediService.urunOrtopediListesi("1", "", "").then((response) => {
                    if (response.status === 200) {
                        this.oUrunList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getIlSelect(gelenIlId) {
                hekimService.hekimIlList(gelenIlId).then((response) => {
                    if (response.status === 200) {
                        this.oHekimList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            hetHekimKlinikList(val) {
                this.hastaForm.klinik = '';
                hekimService.hekimDetay(val).then((response) => {
                    if (response.status === 200) {
                        this.oHekimKlinikList = response.data.klinik;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            inputStyleAlt(val) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hastaForm.adSoyad = splitStr.join(' ');
            },
            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7
            }
        },

    }
</script>

<style scoped>

</style>